export default __webpack_public_path__ + "static/media/Stats_Load_balancer.fbc842dd.svg";